import React from 'react';
import { createComponent } from '@lit/react';
import { IxIcon as LitComp } from '../IxIcon.js';

customElements.define('ix-icon', LitComp);

export const IxIcon = createComponent({
  tagName: 'ix-icon-react',
  elementClass: LitComp,
  react: React,
});
